function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.42711 8.87774H7.01404C7.01404 8.40326 7.19321 7.04848 7.9099 5.42517C8.62659 3.80185 10.3813 2.66916 11.1691 2.30573C11.3339 3.2345 11.6881 5.21316 11.787 5.69774C11.9106 6.30345 13.1 6.33374 12.9455 5.42517C12.8219 4.69831 12.4718 2.53793 12.3122 1.54859C12.5387 1.3265 13.31 0.882305 14.5828 0.882305C15.8557 0.882305 16.6681 1.39716 16.9153 1.65459C16.7145 2.69945 16.3005 4.94665 16.2511 5.57659C16.1893 6.36402 17.286 6.27317 17.4096 5.69774C17.5084 5.23739 17.8936 3.24459 18.0738 2.30573C18.5166 2.42688 19.6741 3.07196 20.7615 4.68316C21.8489 6.29437 22.1208 8.15088 22.1208 8.87774H22.7696C23.0476 8.94841 23.6037 9.27145 23.6037 9.99831C23.6037 10.7252 23.0476 10.9675 22.7696 10.9977H6.42711C6.15421 11.023 5.6084 10.8584 5.6084 9.99831C5.6084 9.1382 6.15421 8.89288 6.42711 8.87774Z",
  fill: "#2F9BFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.85835 21.3511C10.2805 22.2161 11.8041 22.9462 14.5209 22.9462C17.2378 22.9462 18.7614 22.2161 19.1836 21.3511C20.2176 21.163 22.606 21.1931 23.8879 22.8179C25.4903 24.8489 26.3869 27.9673 26.425 28.8136C26.4632 29.6599 26.3678 32.4243 21.9994 33.2141C18.5047 33.846 14.5209 33.8508 14.5209 33.8508C14.5209 33.8508 10.5373 33.846 7.04253 33.2141C2.67412 32.4243 2.57878 29.6599 2.61694 28.8136C2.65509 27.9673 3.55165 24.8489 5.15404 22.8179C6.43595 21.1931 8.82438 21.163 9.85835 21.3511Z",
  fill: "#2F9BFF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.0586 12.3093H7.94971C8.18546 15.2225 9.43256 20.5678 14.5597 20.5678C19.6869 20.5678 21.1973 15.2225 21.0586 12.3093Z",
  fill: "#2F9BFF"
});

function SvgDanilo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanilo);
export default __webpack_public_path__ + "static/media/danilo.c5ef4fdb.svg";
export { ForwardRef as ReactComponent };